/*
    🔥 DEFAULTS DE TODOS LOS CAMPOS

    ⚠️ EL AUTOCOMPLETADO — TRES CAPAS, PORQUE UNA SOLA NO ALCANZA

    1. autoComplete con un valor que Chrome NO reconozca ("nope").
       Frena el autocompletado común.

    2. El truco del readOnly. Chrome NUNCA autocompleta un campo de
       solo lectura. Arranca readOnly y se libera al primer foco, así
       que para el usuario es transparente pero Chrome ya perdió la
       oportunidad de rellenarlo.
       Esto es lo que frena el desplegable de DIRECCIONES GUARDADAS,
       que ignora por completo el atributo autoComplete.

    3. Los data-* para LastPass, 1Password y Dashlane, que inyectan
       sus íconos dentro del input y rompen el diseño.
*/

export const FIELD_AUTOCOMPLETE_OFF = 'nope';

export const FIELD_AUTOCOMPLETE_PASSWORD = 'new-password';

export const onResolveAutoComplete = (type, autoComplete) => {

    if (autoComplete) return autoComplete;              // el que pases vos manda

    if (type === 'password') return FIELD_AUTOCOMPLETE_PASSWORD;

    return FIELD_AUTOCOMPLETE_OFF;
};

export const FIELD_NO_AUTOFILL = {
    autoCorrect: 'off',
    autoCapitalize: 'off',
    spellCheck: 'false',
    'data-lpignore': 'true',
    'data-form-type': 'other',
    'data-1p-ignore': 'true',
};

/*
    🔥 EL TRUCO DEL READONLY

    Devuelve los props que hacen falta. Si el campo ya es de solo
    lectura de verdad, no toca nada.
*/
export const onNoAutofillProps = ({ isReadOnly = false, isDisabled = false } = {}) => {

    if (isReadOnly || isDisabled) return {};

    return {
        readOnly: true,
        onFocus: (event) => event.target.removeAttribute('readonly'),
    };
};
